import React,{useEffect} from "react";
//Styles
import Styles from "./CommonBase.module.scss";

import classnames from "classnames";
import imageLink from "../../images/smooth_profile.png";
import { useLocation } from "react-router-dom";
import { leftMenu } from "../../constants/menu";
import About from "../about/About";
import Contact from "../contact/Contact";
import Home from "../home/Home";


interface CommonBaseProps {
    route:string;
    theme: string;
    backgroundImageUrl: string;
}
const CommonBase = ({route, theme, backgroundImageUrl }: CommonBaseProps) => {

    const query = useQuery()


    return (
        <div>
            <div className={classnames(Styles.full_page, "light")} >
                <div className={Styles.section}>
                     <section id={"home"} className={Styles.section_container}> <Home backgroundImageUrl={backgroundImageUrl} theme={theme} /></section>
                    <section id={"about"} className={Styles.section_container}> <About backgroundImageUrl={backgroundImageUrl} theme={theme} /></section>
                    <section id={"contact"} className={Styles.section_container}> <Contact backgroundImageUrl={backgroundImageUrl} theme={theme} /></section>
                </div>
                <div className={Styles.container}>
                    <div className={Styles.profile_image}>
                        <img src={imageLink} />
                    </div>
                    <div className={Styles.name_title}>
                        <h5 className={Styles.title}>Professional Photography</h5>
                        <div className={Styles.divider}></div>
                        <h1 className={Styles.my_name}>P R I Y A N S H<br />D A T Y A L</h1>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default CommonBase;

function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}